import { TextInput, DateInput } from '@octano/global-ui';
import { Col, Row } from 'reactstrap';
import { TariffFormatter } from '../../../../../../../utils/currency';
import { useTexts } from '../../../hooks/useTexts';

export interface SummaryPetitionProps {
  petitionTitle: string;
  petitionType: string;
  studyPlan: string;
  petitionDate: string;
  evaluationDate: string | undefined;
  section: { id: number; name: string } | undefined;
  paymentAmount?: string | number;
}

export function StudentPetitionSummary({ ...data }: SummaryPetitionProps) {
  const texts = useTexts().detail.resume;
  return (
    <>
      <Row>
        <Col xs={12} sm={6} md={4} xl={''}>
          <TextInput
            name="petitionTitle"
            label={texts.title}
            value={data.petitionTitle}
            disabled
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl="">
          <TextInput
            name="petitionType"
            label={texts.type}
            value={data.petitionType}
            disabled
          />
        </Col>
        <Col xs={12} sm={6} md={4} xl="">
          <TextInput
            name="studyPlan"
            label={texts.studyPlan}
            value={data.studyPlan}
            disabled
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} sm={6} md={4}>
          <DateInput
            name="createdAt"
            label={texts.date}
            value={data.petitionDate}
            disabled
          />
        </Col>
        {data.evaluationDate && (
          <Col xs={12} sm={6} md={4}>
            <DateInput
              name="evaluationDate"
              label={texts.evaluationDate}
              value={data.evaluationDate}
              disabled
            />
          </Col>
        )}
        {data.section && (
          <Col xs={12} sm={6} md={4}>
            <TextInput
              name="section"
              label={texts.section}
              value={data.section.name}
              disabled
            />
          </Col>
        )}
        {data.paymentAmount && (
          <Col sm={6} md={4}>
            <TextInput
              name="payment"
              label={texts.price}
              value={data.paymentAmount}
              formatter={TariffFormatter}
              disabled={true}
            />
          </Col>
        )}
      </Row>
    </>
  );
}
